// extracted by mini-css-extract-plugin
module.exports = {"delete":"StaffList_delete__1tdlJ"};